import { render, staticRenderFns } from "./DashboardTablaComponent.vue?vue&type=template&id=5c53732a&scoped=true&"
import script from "./DashboardTablaComponent.vue?vue&type=script&lang=js&"
export * from "./DashboardTablaComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTablaComponent.vue?vue&type=style&index=0&id=5c53732a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53732a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet,VSimpleTable})
